/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import {useState} from 'react';
import Locale from '../util/Locale';
import Util from '../util/Util';
import './MoveAsset.scss';
import Analytics from '../util/Analytics';
import LoadingIndicator from './LoadingIndicator';

function MoveAsset({title, dstFolder, assetList, setShowModal, onAction}) {
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(null);

    const getStatusIcon = success => {
        if (success === true) {
            return (
                <svg
                    className="fileStatus"
                    fill="none"
                    height="16"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <polyline points="20 6 9 17 4 12" />
                </svg>
            );
        }
        if (success === false) {
            return (
                <svg
                    className="fileStatus"
                    fill="none"
                    height="16"
                    stroke="#CC4331"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
                    <line x1="12" x2="12" y1="8" y2="12" />
                    <line x1="12" x2="12" y1="16" y2="16" />
                </svg>
            );
        }
        return null;
    };

    const renderFooter = () => {
        return (
            <div className="footer-actions">
                {status === null && (
                    <nsemble-button key="CANCEL" text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CANCEL')}
                    </nsemble-button>
                )}
                {status === null && (
                    <LoadingIndicator isLoading={isLoading}>
                        <nsemble-button
                            key="MOVE_ASSET"
                            text
                            onClick={async event => {
                                if (onAction) {
                                    const button = event.currentTarget;
                                    button.disabled = true;
                                    setIsLoading(true);
                                    const result = await onAction();
                                    button.disabled = false;
                                    setStatus(result);
                                    setIsLoading(false);
                                    Analytics.trackEvent(assetList.length > 1 ? 'Asset(s)' : 'Asset', 'Move (Confirm)');
                                }
                            }}
                        >
                            {Locale.getText('MOVE_ASSET')}
                        </nsemble-button>
                    </LoadingIndicator>
                )}
                {status !== null && (
                    <nsemble-button key="CLOSE" text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CLOSE')}
                    </nsemble-button>
                )}
            </div>
        );
    };

    const renderResults = () => {
        if (!status) {
            return null;
        }

        const goodResults = status.some(currentStatus => currentStatus);
        const badResults = status.some(currentStatus => !currentStatus);
        return (
            <div className="results">
                {goodResults && !badResults && <div className="goodResults">{Locale.getText('ALL_FILES_MOVED')}</div>}
                {goodResults && badResults && (
                    <>
                        <div className="goodResults">
                            {goodResults} {Locale.getText('SOME_FILES_MOVED')}
                        </div>
                        <div className="badResults">
                            {badResults} {Locale.getText('SOME_FILES_NOT_MOVED')}
                        </div>
                    </>
                )}
                {!goodResults && badResults && (
                    <div className="badResults">{Locale.getText('ALL_FILES_NOT_MOVED')}</div>
                )}
            </div>
        );
    };

    const renderResult = resultIndex => {
        if (!status) {
            return null;
        }

        return getStatusIcon(status[resultIndex]);
    };

    const renderAssetList = () => {
        return (
            <ul className="asset-list">
                {assetList.map((asset, index) => (
                    <li key={`asset-${index}`}>
                        <span className="result-icon">{renderResult(index)}</span>
                        <span className="result-label">{Util.decodeLabel(asset.label)}</span>
                    </li>
                ))}
            </ul>
        );
    };

    const name = dstFolder;
    return (
        <div>
            <div id="modal-header">
                <h1>{title}</h1>
            </div>
            <div id="modal-body">
                <div className="move-asset">
                    <div className="move-asset-message">
                        {status ? '' : Locale.getText('MOVE_ASSET_MESSAGE', {name})}
                    </div>
                    {renderAssetList()}
                    {renderResults()}
                </div>
            </div>
            <div id="modal-footer">{renderFooter()}</div>
        </div>
    );
}

export default MoveAsset;
